export default __webpack_public_path__ + "static/Romie-Regular-7f67ea7da6399e81a7e2bca60ffbd9c8.woff";